import { Component, Input } from '@angular/core';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {
  RolloverResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover.result';

@Component({
  selector: 'app-rollover-amount-to-declare-result',
  templateUrl: './rollover-amount-to-declare-result.component.html',
  styleUrls: ['./rollover-amount-to-declare-result.component.scss'],
  standalone: false,
})
export class RolloverAmountToDeclareResultComponent {

  @Input()
  options: RolloverOptions;
  @Input()
  results: RolloverResult;

  isSectionCollapsed: boolean = false;

}
